"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverlayDisplayModeResponseT = exports.OverlayDisplayModeResponse = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
/**
 * The current state of the overlay's display mode.
 */
class OverlayDisplayModeResponse {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsOverlayDisplayModeResponse(bb, obj) {
        return (obj || new OverlayDisplayModeResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsOverlayDisplayModeResponse(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new OverlayDisplayModeResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    isVisible() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    isMirrored() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    static startOverlayDisplayModeResponse(builder) {
        builder.startObject(2);
    }
    static addIsVisible(builder, isVisible) {
        builder.addFieldInt8(0, +isVisible, +false);
    }
    static addIsMirrored(builder, isMirrored) {
        builder.addFieldInt8(1, +isMirrored, +false);
    }
    static endOverlayDisplayModeResponse(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createOverlayDisplayModeResponse(builder, isVisible, isMirrored) {
        OverlayDisplayModeResponse.startOverlayDisplayModeResponse(builder);
        OverlayDisplayModeResponse.addIsVisible(builder, isVisible);
        OverlayDisplayModeResponse.addIsMirrored(builder, isMirrored);
        return OverlayDisplayModeResponse.endOverlayDisplayModeResponse(builder);
    }
    unpack() {
        return new OverlayDisplayModeResponseT(this.isVisible(), this.isMirrored());
    }
    unpackTo(_o) {
        _o.isVisible = this.isVisible();
        _o.isMirrored = this.isMirrored();
    }
}
exports.OverlayDisplayModeResponse = OverlayDisplayModeResponse;
class OverlayDisplayModeResponseT {
    constructor(isVisible = false, isMirrored = false) {
        this.isVisible = isVisible;
        this.isMirrored = isMirrored;
    }
    pack(builder) {
        return OverlayDisplayModeResponse.createOverlayDisplayModeResponse(builder, this.isVisible, this.isMirrored);
    }
}
exports.OverlayDisplayModeResponseT = OverlayDisplayModeResponseT;
